import React from 'react'
import {Box, Text} from '@chakra-ui/react'

const Card = (props) => {
    const {color, title, text} = props;
  return (
    <Box w={['15rem','15rem','15rem','20em']} h={['15rem','15rem','15rem','20em']} borderRadius='24px' p='2rem' color='#000' display='flex' flexDirection='column' justifyContent='center' alignItems='center' bg={color}>
        <Text textAlign='center'fontWeight='500' fontFamily='Duplicate Sans' fontSize={['1.35rem','1.3rem','1.3rem','32px']} >{title}</Text>
        <Text color='#445368' textAlign='center' fontFamily='Work Sans' fontSize={['.75rem','.8rem','.8rem', '1rem']} mt='1rem' lineHeight='28px' >{text}</Text>
    </Box>
  )
}

export default Card